export const TENANT = 'uk'
export const SMARTGATEWAY_URL = 'https://uk.api.just-eat.io'
